import {
  SubPageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';

export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    // ── Sub-page (→ scaffolder plugin page) ─────────────────
    SubPageBlueprint.make({
      name: 'templates',
      params: {
        path: 'templates',
        title: 'Templates',
        loader: () =>
          import('../components/scaffolder/CustomTemplatesSubPage').then(m => (
            <m.CustomTemplatesSubPage />
          )),
      },
    }),
  ],
});
